
export type SearchMessagesParams = {
q: string;
page?: number;
size?: number;
};
